export var CarrierNotAvailable = function CarrierNotAvailable(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return CarrierNotAvailableBuilder(strictLocalize).getDescription();
    }
  };
};
var CarrierNotAvailableBuilder = function CarrierNotAvailableBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "OmGYKr",
        defaultMessage: [{
          "type": 0,
          "value": "Carrier unavailable"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "0tajdp",
        defaultMessage: [{
          "type": 0,
          "value": "The carrier that you selected doesn’t ship to the address you’d like to ship to. You can select another carrier or choose Ship on your own."
        }]
      })];
    }
  };
};